import { apiService } from '@/lib/api';
import { AttachmentsModal, AttachmentItem } from '@/components/AttachmentsModal';
import { ExpenseAttachmentInfo } from '@/types';
import { useMemo, useCallback } from 'react';

interface JobExpenseAttachmentsModalProps {
  isOpen: boolean;
  onClose: () => void;
  jobId: string;
  expenseId?: string;
  onAttachmentsUpdated: () => void;
}

export function JobExpenseAttachmentsModal({
  isOpen,
  onClose,
  jobId,
  expenseId,
  onAttachmentsUpdated,
}: JobExpenseAttachmentsModalProps) {
  // When expenseId is provided, filter attachments client-side
  const fetchAttachments = useCallback(async (jobId: string): Promise<AttachmentItem[]> => {
    const all: ExpenseAttachmentInfo[] = await apiService.getJobExpenseAttachments(jobId);
    const filtered = expenseId ? all.filter(a => a.job_expense_id === expenseId) : all;
    return filtered;
  }, [expenseId]);

  const extraUploadFields = useMemo(
    () => (expenseId ? { job_expense_id: expenseId } : undefined),
    [expenseId]
  );

  return (
    <AttachmentsModal
      isOpen={isOpen}
      onClose={onClose}
      ownerId={jobId}
      title={expenseId ? 'Expense Receipts' : 'All Expense Receipts'}
      queryKey="jobExpenseAttachments"
      onAttachmentsUpdated={onAttachmentsUpdated}
      fetchAttachments={fetchAttachments}
      prepareUpload={apiService.prepareExpenseAttachmentUpload.bind(apiService)}
      completeUpload={apiService.completeExpenseAttachmentUpload.bind(apiService)}
      getDownloadUrl={apiService.getExpenseAttachmentDownloadUrl.bind(apiService)}
      updateAttachment={apiService.updateJobExpenseAttachment.bind(apiService)}
      deleteAttachment={apiService.deleteJobExpenseAttachment.bind(apiService)}
      extraUploadFields={extraUploadFields}
    />
  );
}
